module.exports = __webpack_public_path__ + "static/form-one-column-dont-0fd50388bd4d8110ad1d888a78a6f1cf.png";